import angular from "angular";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('json');

export function fraJson(jsonStreng: string): any {
    try {
        return angular.fromJson(jsonStreng);
    } catch (e) {
        debug(`fraJson feilet, jsonStreng: ${jsonStreng}`)
        return undefined;
    }
}
